<template>
    <div class="card">

        <div class="card-header">
            <h3 class="mb-0" slot="header">{{ title }}</h3>
        </div>

        <div class="card-body px-0 pt-0" v-if="hasComment">

            <div v-if="hasGlobalComment" class="px-4 pt-3 pb-4">
                <div v-for="(comment, index) in comments" :key="index">
                    <div v-if="comment.description.length" class="comment" :class="'comment-'+index">
                        <div class="description">{{ comment.description }}</div>
                        <div class="author">-- {{ comment.tester.name }}</div>
                    </div>
                </div>
            </div>

            <div v-for="(competency, index) in competenciesWithComments" :key="index" class="competency">
                <h4 class="px-4 mb-3">{{ competency.name }}</h4>
                <div v-for="(comment, index2) in competency.comments" :key="index2" class="comment px-4" :class="'comment-'+index2">
                    <div class="description">{{ comment.description }}</div>
                    <div class="author">-- {{ comment.tester.name }}</div>
                </div>
            </div>

        </div>
        <div class="card-body" v-else>
            {{ $t('dashboard.no-comment') }}
        </div>
    </div>

</template>

<script>
    export default {

        props: {

            title: {
                type: String,
                required: true
            },

            comments: {
                type: Array,
                required: true
            },

            competencies: {
                type: Object,
                required: true
            },
        },

        computed: {

            hasComment() {
                if (this.hasGlobalComment) {
                    return true
                }
                for (let competency of Object.values(this.competencies)) {
                    if (competency.comments.length) {
                        return true
                    }
                }
                return false
            },

            hasGlobalComment() {
                for (let comment of this.comments) {
                    if (comment.description.length) {
                        return true
                    }
                }
                return false
            },

            competenciesWithComments() {
                return Object.values(this.competencies).filter(competency => competency.comments.length > 0)
            }
        }
    }
</script>

<style lang="css" scoped>

    .comment-1 {
        margin-top: 1.5rem;
    }
    .competency {
        margin-bottom: 2rem;
    }
    .competency:last-child {
        margin-bottom: 0;
    }
    .competency h4 {
        background-color: #f6f9fc;
        color: #8898aa;
        border-bottom: 1px solid #EBEEF5;
        font-size: .65rem;
        text-transform: uppercase;
        padding-top: .65rem;
        padding-bottom: .65rem;
    }
    .description {
        white-space: pre-wrap;
    }
    .author {
        margin-top: 1rem;
        font-weight: bold;
        font-size: 0.8rem;
    }

</style>
